export default {"src":"/_next/static/media/contribution3.852fd60e.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};